import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { uppercaseChar6lahngw3wvwg as uppercaseChar } from './charJs.mjs';
import { toString3o7ifthqydp6e as toString } from '../Char.mjs';
import { charCodeAt1yspne1d8erbm as charCodeAt } from '../js/charSequenceJs.mjs';
import { digitOf3au6ftls3g9n1 as digitOf } from './numberConversions.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../exceptions.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../Unit.mjs';
import { titlecaseImpl1y8hpibh9ddrw as titlecaseImpl } from './_OneToManyTitlecaseMappings.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function equals(_this__u8e3s4, other, ignoreCase) {
  ignoreCase = ignoreCase === VOID ? false : ignoreCase;
  if (_this__u8e3s4 === other)
    return true;
  if (!ignoreCase)
    return false;
  var thisUpper = uppercaseChar(_this__u8e3s4);
  var otherUpper = uppercaseChar(other);
  var tmp;
  if (thisUpper === otherUpper) {
    tmp = true;
  } else {
    // Inline function 'kotlin.text.lowercaseChar' call
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$2 = toString(thisUpper).toLowerCase();
    var tmp_0 = charCodeAt(tmp$ret$2, 0);
    // Inline function 'kotlin.text.lowercaseChar' call
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$6 = toString(otherUpper).toLowerCase();
    tmp = tmp_0 === charCodeAt(tmp$ret$6, 0);
  }
  return tmp;
}
function digitToInt(_this__u8e3s4) {
  // Inline function 'kotlin.also' call
  var this_0 = digitOf(_this__u8e3s4, 10);
  if (this_0 < 0)
    throw IllegalArgumentException().a1('Char ' + toString(_this__u8e3s4) + ' is not a decimal digit');
  return this_0;
}
function titlecase(_this__u8e3s4) {
  return titlecaseImpl(_this__u8e3s4);
}
//region block: exports
export {
  digitToInt as digitToInt2vo19zbx7ksb1,
  equals as equals2ukvbdmtrnsss,
  titlecase as titlecase36e9fbud5gg4t,
};
//endregion

//# sourceMappingURL=Char.mjs.map
